var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuotation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.06961 6.73022C7.69961 7.45022 9.2096 8.3702 9.6496 10.2702C10.9996 16.1702 1.7296 17.7902 0.339599 11.9502C-0.0204005 10.4502 0.0262732 9.00687 0.479606 7.6202C1.82627 3.5002 4.77294 1.2702 9.31961 0.930199C9.45729 0.917154 9.59548 0.941347 9.7196 1.00021C10.0996 1.18021 10.2829 1.42355 10.2696 1.73022C10.2429 2.21022 9.99627 2.51021 9.5296 2.63021C8.0496 3.00355 6.77293 3.73355 5.6996 4.82021C5.56381 4.95481 5.46343 5.12078 5.40724 5.30361C5.35105 5.48645 5.34075 5.68056 5.37726 5.86901C5.41376 6.05746 5.49596 6.23448 5.61665 6.38461C5.73735 6.53473 5.89287 6.65341 6.06961 6.73022Z",
    fill: "#0071FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9404 6.90989C19.8337 7.54323 20.937 8.73655 21.2504 10.4899C22.4804 17.5099 9.82033 17.5399 11.8104 8.77989C12.937 3.82656 16.0037 1.20988 21.0104 0.929883C21.5104 0.896549 21.7837 1.12989 21.8304 1.62989L21.8604 2.02989C21.8666 2.12632 21.8402 2.22176 21.7855 2.30009C21.7309 2.37843 21.6514 2.43486 21.5604 2.45988C20.0804 2.86655 18.737 3.5399 17.5304 4.4799C17.3311 4.63515 17.1775 4.84141 17.0859 5.07686C16.9944 5.3123 16.9682 5.56814 17.0103 5.81724C17.0523 6.06634 17.1609 6.29941 17.3247 6.49177C17.4884 6.68414 17.7012 6.82863 17.9404 6.90989Z",
    fill: "#0071FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotation);
export default __webpack_public_path__ + "static/media/Quotation.3337b010535d14c6a19d2a069e3e4239.svg";
export { ForwardRef as ReactComponent };